module.exports = __webpack_public_path__ + "static/colorbills-6s-1-a05f0727ad5f56d4105d4f983b6552c1.jpg";